import type { IconSvgObject } from './types';

const Joystick03Icon: IconSvgObject = [
  ["path", { d: "M11 5C11 6.65685 9.65685 8 8 8C6.34315 8 5 6.65685 5 5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 8L8 16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 13L13.5 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.5 22H3.5C3.22386 22 3 21.7761 3 21.5V20.2426C3 19.447 3.31607 18.6839 3.87868 18.1213L5.12132 16.8787C5.68393 16.3161 6.44699 16 7.24264 16H16.7574C17.553 16 18.3161 16.3161 18.8787 16.8787L20.1213 18.1213C20.6839 18.6839 21 19.447 21 20.2426V21.5C21 21.7761 20.7761 22 20.5 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Joystick03Icon;
